import { daylightTheme } from './daylight';
import { midnightTheme } from './midnight';
import type { ThemeName, TonyteTheme } from './types';

export const themes: Record<ThemeName, TonyteTheme> = {
  midnight: midnightTheme,
  daylight: daylightTheme,
};

export { daylightTheme, midnightTheme };
export type { ThemeName, TonyteTheme };
